import { motion } from "framer-motion";
import CertSeal from "./CertSeal";

const STANDARDS = [
  "ASTM / ASME",
  "BS",
  "DIN",
  "JIS",
  "BS EN ISO",
  "Client Drawings & Samples",
];

export default function Certifications() {
  return (
    <section id="certifications" className="bg-mist py-20 lg:py-28" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 font-sans font-medium text-[11px] sm:text-xs tracking-[0.12em] uppercase text-steel font-semibold mb-4">
              <span className="w-10 h-[2px] bg-brand" />
              Quality Assurance
            </div>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl text-ink">
              Certified quality,
              <br />
              documented every step.
            </h2>
            <p className="mt-5 text-base text-slate-600 leading-relaxed">
              “At Rahil Engineering Works, quality is never by chance, but by
              choice.” An ISO 9001:2015 certified company — every fastener is
              designed and developed to client specifications, with mill test
              certificates and batch inspection reports supplied as standard —
              across the full M12 to M100 and ¼" to 4" range.
            </p>

          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.12 }}
            className="lg:col-span-5 lg:pt-4"
          >
            <div className="flex justify-center lg:justify-start mb-9">
              <CertSeal size={200} />
            </div>

            <div data-testid="standards-chips">
              <div className="font-sans font-medium text-[11px] tracking-[0.12em] uppercase text-steel mb-4">
                Grades & standards we manufacture to
              </div>
              <div className="flex flex-wrap gap-2.5">
                {STANDARDS.map((s) => (
                  <span
                    key={s}
                    className="font-sans font-semibold text-[11px] font-medium tracking-[0.04em] bg-white border border-steel-light text-navy px-4 py-2 rounded-full hover:border-brand hover:text-brand transition-colors duration-300"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
